import styled from 'styled-components'
import { mobile } from '../../constants/breakpoints'

export const Page = styled.div`
  width: 100%;
  margin: 72px auto 0 auto;

  @media (max-width: ${mobile}) {
    display: none;
  }
`

export const HeadingBannerDesktop = styled.div`
  width: 100%;
  height: 585px;
  padding: 66px 100px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  background: linear-gradient(181deg, #f7fbff 7.16%, #f8fcff 74.48%);
  background-position: right;
  background-size: contain;
  background-repeat: no-repeat;
  gap: 40px;

  & > * {
    position: relative;
  }

  & > h1 {
    color: #4c5197;
    font-family: Poppins;
    font-size: 60px;
    font-style: normal;
    font-weight: 600;
    line-height: 80px;
    margin: 0;

    & > span {
      background: #c779de;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: Poppins;
      font-size: 60px;
      font-style: normal;
      font-weight: 600;
      line-height: 80px;
    }
  }

  & > div {
    color: #4c5197;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  img {
    position: absolute;
    right: 0;
    top: 0;
  }
`

export const SignUpButton = styled.a`
  display: flex;
  width: 320px;
  height: 62.7px;
  padding: 4px 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  outline: none;
  border: none;
  border-radius: 10px;
  background: linear-gradient(94deg, #ee9bde -34.17%, #9251e2 117.1%);

  color: #fff;
  text-align: center;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 200% */
  letter-spacing: 1.3px;
  text-decoration: none;

  &:hover {
    transition: box-shadow 0.2s ease-out;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  &:disabled:hover {
    cursor: default;
    box-shadow: none;
  }
`

export const DesktopBodyWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const CardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  margin: 50px 0;
  overflow-x: hidden;

  h2 {
    margin: 0;
    color: #2c3069;
    text-align: center;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 500;
    line-height: 25.5px;

    & > span {
      color: #c779de;
      font-family: Poppins;
      font-size: 30px;
      font-style: normal;
      font-weight: 700;
      line-height: 25.5px;
    }
  }
`

export const CardsWrapper = styled.div`
  width: calc(100% + 140px);
  display: flex;
  justify-content: space-between;

  gap: 20px;

  padding: 0 140px;
`

export const Card = styled.div`
  border-radius: 16px;
  max-width: 382px;
  width: 100%;

  aspect-ratio: 1 / 1;

  h3 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    height: 62px;
    color: #2c3069;
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 25.5px; /* 127.5% */
  }

  img {
    width: 100%;
    height: 302px;
    object-fit: cover;
    border-radius: 16px;
  }
`
